import axios from "axios";
import { CONFIGURATIONS } from "./envConfig";
import { errorMessages } from "../constants/frontendErrorMessages";

export const api = axios.create(
    {
        // baseURL: `${CONFIGURATIONS.API_BASE_URL}/auth`
        baseURL: `${CONFIGURATIONS.API_BASE_URL}/`,
        withCredentials: true, // Ensures cookies are included in all requests

    }
)

api.interceptors.request.use(
    (config) =>{

        if(!config?.voidAuth){
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }else{
            delete config.voidAuth;
        }
        // console.log(config)
        return config     
    },
    (error) => {
        console.log("error")
        return Promise.reject(error);
    }
);

api.interceptors.response.use(

    async (response) => response,
    async (error) => {

        /*
        * console.log(error?.response?.status); ===========>  status code (400/401...) that set from the backend
        *
        * console.log(error?.response?.data); =============>  does not includes any status code
        *
        *       message : "Incorrect Password. Please Try Again"
        *       stack : "fgtgtg.t.gtg.1"
        *       status : "fail"
        * 
        * console.log(error?.response?.data?.statusCode); =>  undefined result
        */        

        if (error.response?.status === 401) {
            console.log("unauthorized triggered and localstorage cleared!");
            localStorage.clear();
            window.location.reload();
        }

        if (error.response) {
            // Existing response with error status
            const data = error.response.data;
            error.message = data?.message || errorMessages.ERROR_OCCURRED;
            error.code = `${error.response?.status}` || '500';
        } else {            
            // Error setting up the request
            error.message = error.message || errorMessages.UNKNOWN_ERROR_OCCURRED;
            error.code = '500';
        }
        
        return Promise.reject(error);
    },
)
